import Button from "~/components/button.tsx";
import type { ModalProps } from "~/components/modal.tsx";
import Modal from "~/components/modal.tsx";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";
import classes from "./remove-colour-modal.module.css";

type RemoveColourModalProps = Pick<ModalProps, "id"> & {
	readonly onConfirm: () => void;
};

function RemoveColourModal({ id, onConfirm }: RemoveColourModalProps) {
	const t = useTranslator();
	return (
		<Modal id={id} size="small" bodyClassName={classes["remove-modal-body"]}>
			{t(`Are you sure you want to revert your design and remove the color?`)}
			<Button variant="blue" type="button" onClick={onConfirm}>
				{t("Remove color")}
			</Button>
		</Modal>
	);
}

export default RemoveColourModal;
